
import { UnidadesMedida } from "@/interfaces/Produto";
import { defineComponent, PropType } from "vue"

export default defineComponent({
  name: "ProdutoUnidadeMedidaChipSelector",
  props: {
    unidadesMedida: {
      type: Array as PropType<UnidadesMedida[]>,
      required: true,
    },
    smallSize: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedUn: "",
    };
  },
  computed: {
    getUnidadesMedida(): UnidadesMedida[] {
      //exibe apenas as unidades ativas
      const list = this.unidadesMedida?.filter((un: UnidadesMedida) => un.situacao != "I") || [];

      // alinha em ordem alfabetica descendente
      list.sort((a: any, b: any) => {
        if (a.id < b.id) {
          return 1;
        }
        if (a.id > b.id) {
          return -1;
        }
        return 0;
      });

      return list;
    },
  },
  methods: {
    onUnidadeMedidaChange(unidadeMedida: string) {
      this.selectedUn = unidadeMedida;
      this.$emit("change", unidadeMedida);
      this.$emit("input", unidadeMedida);
    },
    getTooltipText(item: UnidadesMedida): string {
      const fator = Math.floor(Number(item.fatorQtde)) || 1;
      const fatorText = fator ? ` - x${fator}` : '';
      return `${item?.descricao || ""}${fatorText}`;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value: string) {
        this.selectedUn = value;
      },
    },
  },
});
